export const queryBuilder = (filters) => {
  let query = '';
  if(filters.length > 0) {
    query += '?';
    filters.map(filter => query += `&${filter}`)
    query = query.replace('&', '')
  }
  return query
}